import { UseMutationOptions } from '@tanstack/react-query';

import { CuredApiPaths, ApiMethods } from '../../models/enums';
import { PathWithID } from '../../models/types';
import useMutation from '../useMutation';

import MutationKeys from './keys';

const useDeleteCampaign = (campaignId: string, mutateOptions?: UseMutationOptions<unknown, Error>) =>
    useMutation(
        MutationKeys.DELETE_CAMPAIGN,
        new PathWithID(CuredApiPaths.CAMPAIGNS, campaignId),
        mutateOptions,
        ApiMethods.DELETE
    );

export default useDeleteCampaign;
